import styled from 'styled-components'
import { Button } from '~/shared/components/Button'

export const Styles = {
  StyledForm: styled.form`
    display: flex;
    flex-direction: column;
    height: 100%;
  `,

  Title: styled.h1`
    font-weight: 700;
    font-size: 22px;
    line-height: 24px;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.colors.defaultTextColor};
  `,

  Subtitle: styled.h2`
    font-size: 14px;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.defaultTextColor};
    margin-bottom: 24px;
  `,

  InputWrapper: styled.div`
    width: 100%;
    position: relative;
  `,

  StyledButton: styled(Button)`
    margin-top: auto;
  `,
} as const
